module.exports = __webpack_public_path__ + "img/bg-news2.958317a1.png";